// extracted by mini-css-extract-plugin
export default {"header":"WSCardHeader-module_header-qtel0"};